import { adminInfo } from './adminInfo';
import { BaseClass } from './base_class';
import { BaseInterface } from './base_interface';

export class Crest extends BaseClass implements BaseInterface {

    constructor(){
        super();
        this.id = 0;
        this.description = "";
        this.color_1 = "";
        this.color_2 = "";
        this.color_3 = "";
        this.base64 = "";
        this.master = 0;
        this.group_id = 0;
        this.cresttype_id = 0;
        this.created_at = null;
        this.updated_at = null;
        this.deleted_at = null;
    }

    controls: any = {
        id: "number",
        description: "string",
        base64: "string",
        group_id: "number",
        cresttype_id: "number"
    }

    id: number;
    description: string;
    color_1: string;
    color_2: string;
    color_3: string;
    base64: string;
    master: number;
    group_id: number;
    cresttype_id: number;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;

}